import { jsx, Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
const NavigationButtonWrapper = ({
  children,
  isScrollbar = false,
  sx
}) => {
  return isScrollbar ? /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        position: "absolute",
        zIndex: 1,
        ...sx
      },
      children
    }
  ) : /* @__PURE__ */ jsx(Fragment, { children });
};
export {
  NavigationButtonWrapper
};
